import { Field, Listbox, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/utils/css";

export const PredictionDropdown = ({ items, value, setValue, className, disabled }) => {
    return (
        <Field
            className={cn("flex flex-col bg-cm-p-surface-container h-[38px] px-4 py-2 min-w-[120px] rounded-[58px]", className, {
                "opacity-70 cursor-not-allowed": disabled,
            })}
            disabled={disabled}
        >
            <Listbox
                value={value?.id}
                onChange={(v) => {
                    setValue(v);
                }}
            >
                {({ open }) => (
                    <>
                        <ListboxButton className="inline-flex flex-row justify-between">
                            <span className="text-cm-p-text-primary text-sm/[22px] font-medium">{value?.text}</span>
                            <ChevronDown className={`opacity-50 text-cm-p-text-primary transition ease-in ${open ? "rotate-180" : ""}`} />
                        </ListboxButton>
                        <ListboxOptions
                            anchor="bottom"
                            modal={false}
                            className="z-30 flex flex-col mt-3 rounded-xl bg-cm-p-surface-container py-1 w-[120px] border border-cm-p-outline drop-shadow-[0_4px_4px_rgba(0,0,0,0.15)]"
                        >
                            {items.map((item) => (
                                <ListboxOption
                                    key={item.id}
                                    value={item.id}
                                    className="inline-flex min-h-[32px] px-4 items-center hover:bg-[rgba(196,205,202,0.1)] data-[focus]:bg-[rgba(196,205,202,0.1)] cursor-pointer"
                                >
                                    <span className="text-cm-p-text-primary text-sm/[22px] font-semibold">{item.text}</span>
                                </ListboxOption>
                            ))}
                        </ListboxOptions>
                    </>
                )}
            </Listbox>
        </Field>
    );
};
